/*
  Remal: mega menu otwierane po najechaniu kursorem (30.10.2026).
  Działa tylko na komputerze z myszką i ekranem od 990 px.
  Telefon, tablet i klawiatura działają jak w oryginalnym motywie Dawn.
*/
(function () {
  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 250;
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function init() {
    var menus = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu header-menu'));
    if (!menus.length) return;

    function setOpen(menu, open) {
      var details = menu.querySelector('details');
      if (!details) return;
      var summary = details.querySelector('summary');
      if (details.open !== open) details.open = open;
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function clearTimers(menu) {
      clearTimeout(menu._remalOpenTimer);
      clearTimeout(menu._remalCloseTimer);
    }

    function closeOthers(current) {
      menus.forEach(function (menu) {
        if (menu !== current) {
          clearTimers(menu);
          setOpen(menu, false);
        }
      });
    }

    menus.forEach(function (menu) {
      var summary = menu.querySelector('summary');

      menu.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimers(menu);
        menu._remalOpenTimer = setTimeout(function () {
          closeOthers(menu);
          setOpen(menu, true);
        }, OPEN_DELAY);
      });

      menu.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(menu._remalOpenTimer);
        menu._remalCloseTimer = setTimeout(function () {
          setOpen(menu, false);
        }, CLOSE_DELAY);
      });

      if (summary) {
        summary.addEventListener('click', function (event) {
          // event.detail === 0 oznacza klawiaturę: zostawiamy zachowanie motywu.
          if (!mq.matches || event.detail === 0) return;
          event.preventDefault();
          clearTimers(menu);
          closeOthers(menu);
          setOpen(menu, true);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
